import type { UiNode } from "@ory/kratos-client";
import type React from "react";
import type { FlowContext } from "~/components/KratosFlow/Flow";
import type { FormDispatcher, ValueSetter } from "./helpers";
import {
	isUiNodeAnchorAttributes,
	isUiNodeImageAttributes,
	isUiNodeInputAttributes,
	isUiNodeScriptAttributes,
	isUiNodeTextAttributes,
} from "./integrations/ui";
import { NodeAnchor } from "./NodeAnchor";
import { NodeImage } from "./NodeImage";
import { NodeInput } from "./NodeInput";
import { NodeScript } from "./NodeScript";
import { NodeText } from "./NodeText";

interface Props {
	node: UiNode;
	disabled: boolean;
	// biome-ignore lint/suspicious/noExplicitAny: any is required for the value
	value: any;
	setValue: ValueSetter;
	dispatchSubmit: FormDispatcher;
	context: FlowContext;
	// biome-ignore lint/suspicious/noExplicitAny: any is required for the validate function
	validate?: (value: any) => boolean;
}

export const Node: React.FC<Props> = ({
	node,
	value,
	setValue,
	disabled,
	dispatchSubmit,
	context,
	validate,
}) => {
	if (isUiNodeImageAttributes(node.attributes)) {
		return <NodeImage node={node} attributes={node.attributes} />;
	}

	if (isUiNodeScriptAttributes(node.attributes)) {
		return <NodeScript node={node} attributes={node.attributes} />;
	}

	if (isUiNodeTextAttributes(node.attributes)) {
		return <NodeText node={node} attributes={node.attributes} />;
	}

	if (isUiNodeAnchorAttributes(node.attributes)) {
		return <NodeAnchor node={node} attributes={node.attributes} />;
	}

	if (isUiNodeInputAttributes(node.attributes)) {
		return (
			<NodeInput
				context={context}
				dispatchSubmit={dispatchSubmit}
				value={value}
				setValue={setValue}
				node={node}
				disabled={disabled}
				attributes={node.attributes}
				validate={validate}
			/>
		);
	}

	return <></>;
};
